import { Provider } from './providers.js'


import { GeoLocationMessage } from './geoLocation';

export default class GeoLocationEngine extends Provider
{

    static get isSupported(){
        return !!navigator.geolocation;
    }

    constructor()
    {
        super();
        this.watchingId = null;
    }

    start(){
        if(this.watchingId !== null) return;

        if(!GeoLocationEngine.isSupported){
            const code = 42;
            const message = "geo location is not supported on this device";
            this._broadcastValue(GeoLocationMessage.newErrorCoords(code, message));
            return;
        }

        console.log("starting native geo location service");

        const positionOptions = {
            enableHighAccuracy: true
        };
        this.watchingId = navigator.geolocation.watchPosition(this.successHandler.bind(this), this.errorHandler.bind(this), positionOptions);
    }

    stop(){
        navigator.geolocation.clearWatch(this.watchingId);
        this.watchingId = null;
    }

    successHandler(p) {
        console.log("new geolocation", p.coords);

        this._broadcastValue(GeoLocationMessage.newCoords(p.coords));
    };

    errorHandler(e) {
        // 1 = permission denied
        // 2 = position unavailable
        // 3 = timeout
        console.log("geolocation error", e.code, e.message);
        this._broadcastValue(GeoLocationMessage.newErrorCoords(e.code, e.message));
    }
}
